<template>
  <div class="bg-white border-bottom">
    <div class="row row align-items-start no-gutters">
      <div class="col">
        <h1 class="mb-0 px-3 py-4">{{ title }}</h1>
      </div>
      <div class="col-auto p-3">
        <slot name="right" />
      </div>
    </div>
    <div
      v-if="$slots.default"
      class="container-fluid pb-3">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
